import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import { useNavigate } from "react-router-dom";

import "swiper/css";
import "swiper/css/pagination";
import "./PartnerCards.css";

const cardsData = [
    {
        id: 1,
        category: "Content",
        title: "CREATOR",
        bonus: "Bonus Benvenuto",
        linkText: "Link affiliato",
        tags: ["VIDEO/FOTO", "REELS", "CREATIVITÀ", "STORYTELLING"],
        colorClass: "creator-card",
        path: "/contentcreator",
        backContent: {
            title: "Content Creators",
            subtitle: "Sei creativo e ami comunicare online?",
            description: "Realizza contenuti originali, racconta il brand con il tuo stile e coinvolgi la tua community attraverso video, reel e storytelling."
        }
    },
    {
        id: 2,
        category: "Fashion&Design",
        title: "ADDICTED",
        bonus: "Bonus Benvenuto",
        linkText: "Link affiliato",
        tags: ["OUTFIT", "STYLE", "CREATIVITÀ", "GRWM"],
        colorClass: "fashion-card",
        path: "/fashion-design",
        backContent: {
            title: "Fashion & designer addicted",
            subtitle: "Hai passione per la moda e per lo stile?",
            description: "Crea contenuti, racconta il brand e condividi outfit con la tua community."
        }
    },
    {
        id: 3,
        category: "Tech&",
        title: "INNOVAZIONE",
        bonus: "Bonus Benvenuto",
        linkText: "Link affiliato",
        tags: ["SCREEN REC.", "SVILUPPATORI AR", "DESIGNER 3D", "GAME DESIGNER"],
        colorClass: "tech-card",
        path: "/tech",
        backContent: {
            title: "Tech & Digital Creators",
            subtitle: "Ti piace la tecnologia e il mondo digitale?",
            description: "Mostra il configuratore, registra lo schermo mentre esplori il sito o spiega come funziona il progetto."
        }
    },
    {
        id: 4,
        category: "Community",
        title: "BUILDER",
        bonus: "Bonus Benvenuto",
        linkText: "Link affiliato",
        tags: ["COMMUNITY", "NETWORKING", "CREATIVITÀ", "RELATION"],
        colorClass: "tech-card",
        path: "/communities",
        backContent: {
            title: "Community Builder",
            subtitle: "Hai una community attiva o ami condividere scoperte con le persone?",
            description: "Parla del brand, condividi il tuo link e fai crescere la community."
        }
    }
];

const PartnerCards = () => {
    const navigate = useNavigate();
    const [flippedCards, setFlippedCards] = useState({});

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 1024) {
                setFlippedCards({});
            }
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleCardClick = (id) => {
        if (window.innerWidth <= 1024) {
            setFlippedCards(prev => ({
                ...prev,
                [id]: !prev[id]
            }));
        }
    };

    return (
        <div className="swiper-container-wrapper">
            <Swiper
                modules={[Pagination]}
                spaceBetween={20}
                slidesPerView={1}
                grabCursor={true}
                pagination={{ clickable: true }}
                breakpoints={{
                    768: { slidesPerView: 2, spaceBetween: 20 },
                    1024: { slidesPerView: 4, spaceBetween: 20 }
                }}
                className="partner-swiper"
            >
                {cardsData.map((card) => (
                    <SwiperSlide key={card.id}>
                        <div
                            className={`card-uiverse ${card.colorClass} ${flippedCards[card.id] ? 'is-flipped' : ''}`}
                            onClick={() => handleCardClick(card.id)}
                        >
                            <div className="card-inner">
                                <div className="card-front">
                                    <div className="content-wrap">
                                        <p className="category-text">{card.category}</p>
                                        <p className="heading-main">{card.title}</p>
                                        <p className="bonus-text">{card.bonus} <span className="bonus-amount">25€</span></p>
                                        <p className="link-info">{card.linkText}</p>
                                        <div className="tags-grid">
                                            {card.tags.map((tag, index) => (
                                                <span key={index} className="tag-pill">{tag}</span>
                                            ))}
                                        </div>

                                    </div>
                                </div>
                                <div className="card-back">
                                    <div className="back-content">
                                        <p className="back-subtitle">{card.backContent.subtitle}</p>
                                        <p className="back-description">{card.backContent.description}</p>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default PartnerCards;